// import '../node_modules/semantic-ui-sass/js/api'
// import '../node_modules/semantic-ui-sass/js/colorize'
// import '../node_modules/semantic-ui-sass/js/form'
// import '../node_modules/semantic-ui-sass/js/state'
import '../node_modules/semantic-ui-sass/js/visibility'
// import '../node_modules/semantic-ui-sass/js/visit'
// import '../node_modules/semantic-ui-sass/js/site'
// import '../node_modules/semantic-ui-sass/js/accordion'
// import '../node_modules/semantic-ui-sass/js/checkbox'
// import '../node_modules/semantic-ui-sass/js/dimmer'
// import '../node_modules/semantic-ui-sass/js/dropdown'
// import '../node_modules/semantic-ui-sass/js/embed'
// import '../node_modules/semantic-ui-sass/js/modal'
// import '../node_modules/semantic-ui-sass/js/nag'
// import '../node_modules/semantic-ui-sass/js/popup'
// import '../node_modules/semantic-ui-sass/js/progress'
// import '../node_modules/semantic-ui-sass/js/rating'
// import '../node_modules/semantic-ui-sass/js/search'
// import '../node_modules/semantic-ui-sass/js/shape'
import '../node_modules/semantic-ui-sass/js/sidebar'
// import '../node_modules/semantic-ui-sass/js/sticky'
// import '../node_modules/semantic-ui-sass/js/tab'
import '../node_modules/semantic-ui-sass/js/transition'



// WEBPACK FOOTER //
// ./styles/semantic.js